export default __webpack_public_path__ + "static/springandsummer (10)-d803fe4a7bb5509ee4761b03f46b78c8.jpeg";